import { logEvent } from '../logs';
import { DEBUG_CONSOLE_MODE } from '../logs';

export const getNotificationLogger = (logger: string) => {
    return DEBUG_CONSOLE_MODE
        ? (event, args?) => logEvent('NOTIFICATIONS', `${logger}: ${event}`, args, 'deepskyblue')
        : () => {};
};
